import React , {useEffect}from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {Grid,Hidden,Tabs,Tab} from '@material-ui/core';
import { theme } from '../theme';
import Shortfilms from './works/Shortfilms.jsx';
import Streetplays from './works/Streetplay.jsx';
import Monoacts from './works/Monoacts.jsx';
import Cotm from './works/cotm.jsx';
// import './ourworks.css'
import {Helmet} from "react-helmet";

const OurWork = ({ type }) => {
  const [value, setValue] = React.useState(0);

const see=()=>{
  if(type==='shortfilm'){
    setValue(1);
    document.getElementById('shortfilm').style.display = 'block';
    document.getElementById('streetplay').style.display = 'none';
   
  }
  else{
    setValue(0);
    document.getElementById('shortfilm').style.display = 'none';
    document.getElementById('streetplay').style.display = 'block';
  }
}

useEffect(see, [])

  function handleChange1(event, newValue) {
    setValue(newValue);
    if (newValue===0) {
      document.getElementById('shortfilm').style.display = 'none';
      document.getElementById('streetplay').style.display = 'block';
      document.getElementById('monoact').style.display = 'none';
      document.getElementById('cotm').style.display = 'none';
    }
    else if (newValue===1) {
      document.getElementById('shortfilm').style.display = 'block';
      document.getElementById('streetplay').style.display = 'none';
      document.getElementById('monoact').style.display = 'none';
      document.getElementById('cotm').style.display = 'none';
    }
    else if (newValue===2) {
      document.getElementById('shortfilm').style.display = 'none';
      document.getElementById('streetplay').style.display = 'none';
      document.getElementById('monoact').style.display = 'block';
      document.getElementById('cotm').style.display = 'none';
    }
    else{
      document.getElementById('shortfilm').style.display = 'none';
      document.getElementById('streetplay').style.display = 'none';
      document.getElementById('monoact').style.display = 'none';
      document.getElementById('cotm').style.display = 'block';
    }
    
  }

  return (
    <MuiThemeProvider theme={theme}>
      <br />
      <br />
      <Helmet>
          <title>Streetplays, Shortfilms Monoacts and COTM || Aura</title>
          <meta
            name="description"
            content="Collection of the performance by Team Aura consisiting of our Streetplays, Shortfilms, Monoacts and Cause of The Month."
          />
        </Helmet>

      <div id="faq" className="content-wrapper" style={{padding:'0'}}>
        <Grid container >
          <Grid id="faqContent" item xs={12} md={11} className="content-wrapper fadeInUp" style={{ animationDelay: '0.5s' }}>
            <Tabs
              value={value}
              onChange={handleChange1}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              centered
            >
              <Tab label="StreetPlays" style={{ fontSize: '1rem',color:'white',outline:'none' }} />
              <Tab label="Short Films" style={{ fontSize: '1rem', color:'white',outline:'none' }} />
              <Tab label="Monoacts" style={{ fontSize: '1rem', color:'white',outline:'none' }} />
              <Tab label="COTM" style={{ fontSize: '1rem', color:'white',outline:'none' }} />
            </Tabs>
          </Grid>
          <Grid item xs={12} md={11} id="streetplay" className="content-wrapper" style={{margin:'0 auto'}}>
            <Streetplays />
          </Grid>
          <Grid item xs={12} md={11} id="shortfilm" className="content-wrapper hides" style={{margin:'0 auto'}}>
            <Shortfilms />
          </Grid>
          <Grid item xs={12} md={11} id="monoact" className="content-wrapper hides" style={{margin:'0 auto'}}>
            <Monoacts/>
          </Grid>
          <Grid item xs={12} md={11} id="cotm" className="content-wrapper hides" style={{margin:'0 auto'}}>
            <Cotm/>
          </Grid>
        </Grid>
        <Grid container >
          <Grid item md>
            <Hidden smDown>
              <div className="give-margin" />
            </Hidden>
          </Grid>
        </Grid>
      </div>
    </MuiThemeProvider>
  );
};

export default OurWork;
